import React from "react";

import svg from "../../assets/images/icons/Form Controls/List Entry Control.svg";

export const ListEntryIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "List Entry"}
    />
);
